import React from "react";
import _ from "lodash";
import Loading from "./Loading";
import Highchart from "./Highchart";

export default class StrikeZoneChart extends React.Component {
  formatBucketData(bucket) {
    return {
      name: bucket.name,
      x: bucket.offset,
      y: Math.round(bucket.calledStrikePct * 100)
    };
  }

  render() {
    let series = [];
    if (!this.props.isLoading) {
      const records = this.props.data.records.map(record => {
        const recordData = record.buckets.map(this.formatBucketData);
        return {
          name: `${record.name} [${record.version}]`,
          data: recordData
        };
      });

      const totalsData = this.props.data.totals.map(this.formatBucketData);

      const totals = {
        name: "Totals",
        data: totalsData,
        dashStyle: "LongDash"
      };
      series = _.concat(records, totals);
    }

    const options = {
      chart: {
        type: "spline"
      },
      title: {
        text: null
      },
      yAxis: {
        title: {
          text: "Rate (%)"
        },
        max: 100
      },
      xAxis: {
        title: {
          text: "Ball Location (ft)"
        },
        gridLineWidth: 1
      },
      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "middle"
      },
      tooltip: {
        valueSuffix: "%"
      },
      plotOptions: {
        series: {
          lineWidth: 2,
          marker: {
            symbol: "circle",
            enabled: false
          }
        }
      },
      series: series
    };

    return (
      <div>
        <h1>Strike Zone Chart</h1>
        {this.props.isLoading ? (
          <Loading />
        ) : (
          <Highchart containerId="chart" options={options} />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StrikeZoneChart.js